import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

const unitsAdapter = createEntityAdapter({
  selectId: (unit) => unit._id
});

const initialState = {
  ui: {
    loading: false,
    creating: false,
    stats: {
      pageCount: 1
    }
  },
  data: [],
  unit_group: {},
  deleted_product: unitsAdapter.getInitialState()
};

export const unitsReducerSlice = createSlice({
  name: 'units',
  initialState,
  reducers: {
    get_units: (state) => {
      state.ui.loading = true;
    },
    get_units_success: (state, { payload }) => {
      state.ui.loading = false;
      state.data = payload.units;
      state.ui.stats = payload.stats;
    },
    get_units_error: (state) => {
      state.ui.loading = false;
    },
    create_units: (state) => {
      state.ui.creating = true;
    },
    create_units_succes: (state, { payload }) => {
      state.ui.creating = false;
      state.data.unshift(payload);
    },
    create_units_error: (state) => {
      state.ui.creating = false;
    },
    delete_units: (state) => {
      state.ui.creating = true;
    },
    delete_units_success: (state, { payload }) => {
      state.ui.creating = false;
      state.data = state.data.filter((data) => data._id !== payload._id);
    },
    delete_units_error: (state) => {
      state.ui.loading = false;
    },
    update_units: (state) => {
      state.ui.creating = true;
    },
    update_units_success: (state, { payload }) => {
      state.ui.creating = false;
      const previousData = state.data;
      const index = previousData.findIndex((data) => data._id === payload._id);
      previousData[index] = payload;
      state.data = previousData;
    },
    update_units_error: (state) => {
      state.ui.loading = false;
    },
    get_one_unit: (state) => {
      state.ui.loading = true;
    },
    get_one_unit_success: (state, { payload }) => {
      state.ui.loading = false;
      state.product_group = payload;
    },
    get_one_unit_error: (state) => {
      state.ui.loading = false;
    }
  }
});

export const {
  get_units,
  get_units_success,
  get_units_error,
  create_units,
  create_units_succes,
  create_units_error,
  delete_units,
  delete_units_success,
  delete_units_error,
  update_units,
  update_units_success,
  update_units_error,
  get_one_unit,
  get_one_unit_success,
  get_one_unit_error
} = unitsReducerSlice.actions;

export default unitsReducerSlice.reducer;
